<template>
  <div>
    <div class="titleh1">
      <code />
      {{ title }}
    </div>
    <vxe-toolbar id="toolbarId_pa3" style="text-align: right;padding-right: 10px;">
      <template v-slot:buttons>
        <el-button @click="funcSave">保存</el-button>
      </template>
    </vxe-toolbar>
    <el-table ref="xTable" resizable border :data="tableData">
      <el-table-column width="60" type="index" label="序号" />
      <el-table-column width="360" prop="roleCode" label="角色">
        <template v-slot="{ row }">
          <template v-if="row.isEdit">
            <el-tooltip
              v-model="row.roleCodeVisible"
              class="item"
              popper-class="verify-tip"
              effect="light"
              content="请选择角色"
              placement="right"
              trigger="manual"
            >
              <el-select v-model="row.roleCode" placeholder="请选择" size="mini">
                <el-option key value label="请选择" />
                <el-option v-for="(v,k) in roleMap" v-show="canSelectRole(row.roleCode,k)" :key="k" :value="k" :label="v" />
              </el-select>
            </el-tooltip>
          </template>
          <template v-else>{{ roleMap[row.roleCode] }}</template>
        </template>
      </el-table-column>
      <el-table-column width="90" prop="isEnable" label="启用">
        <template v-slot="{ row }">
          <template v-if="row.isEdit">
            <el-select v-model="row.isEnable" placeholder="请选择" size="mini">
              <el-option v-for="(v,k) in enableOptions" :key="k" :value="k" :label="v" />
            </el-select>
          </template>
          <template v-else>{{ enableOptions[row.isEnable] }}</template>
        </template>
      </el-table-column>
      <el-table-column>
        <template v-slot:header>
          <vxe-button type="text" @click="insertEvent(-1)">
            <i class="el-icon-plus" />
          </vxe-button>
        </template>
        <template v-slot="{ row,$index}">
          <vxe-button type="text" @click="insertEvent($index)">
            <i class="el-icon-plus" />
          </vxe-button>
          <vxe-button type="text" @click="delRowEvent(row,$index)">
            <i class="el-icon-minus" />
          </vxe-button>
          <template v-if="row.isEdit">
            <vxe-button type="text" @click="saveRowEvent(row)">
              <i class="el-icon-check" />
            </vxe-button>
            <vxe-button type="text" @click="cancelRowEvent(row,$index)">
              <i class="el-icon-close" />
            </vxe-button>
          </template>
          <template v-else>
            <vxe-button type="text" @click="editRowEvent(row)">
              <i class="el-icon-edit" />
            </vxe-button>
          </template>
          <vxe-button type="text" @click="upRowEvent($index)">
            <i class="el-icon-sort-up" />
          </vxe-button>
          <vxe-button type="text" @click="downRowEvent($index)">
            <i class="el-icon-sort-down" />
          </vxe-button>
        </template>
      </el-table-column>
    </el-table>
    <!--<vxe-toolbar id="toolbarId_pa4" style="text-align: right;padding-right: 10px;">
      <template v-slot:buttons>
        <el-button @click="funcSave">保存</el-button>
      </template>
    </vxe-toolbar>-->
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      title: '财务开票审批流程',
      tableData: [],
      roleMap: {},
      enableOptions: { '0': '是', '1': '否' },
      validRules: {
        roleCode: [{ required: true, message: '请选择角色' }],
        isEnable: [{ required: true, message: '请选择是否启用' }]
      },
      listQuery: {
        step: '',
        isFinished: '',
        roleCode: '',
        type: 5,
        isEnable: '',
        pageNum: 1,
        pageSize: 1000,
        sortField: 'step',
        sortType: 'asc',
        total: 0
      }
    }
  },
  async created() {
    let $this = this;
    this.getRoleMap(function(){
      $this.findList();
    });
  },
  methods: {
    canSelectRole(code,role){
      for(let i=0,len=this.tableData.length;i<len;i++){
        if(this.tableData[i].roleCode==role&&this.tableData[i].roleCode!=code){
          return false;
        }
      }
      return true;
    },
    getRoleMap(callBack) {
      request({ url: `/ntocc-basic-api/role`, method: 'get', params: {branchCode:this.$store.state.user.party.branchCode}}).then(
        response => {
          const data = response.data.records
          if (data && data.length > 0) {
            for (const i in data) {
              this.roleMap[data[i].code] = data[i].roleName
            }
            callBack();
          }
        }
      )
    },
    insertEvent(rowIndex) {
      const record = {
        isEnable: '0',
        isEdit: true,
        name: this.title,
        type: this.listQuery.type
      }
      this.tableData.splice(rowIndex + 1, 0, record)
    },
    editRowEvent(row) {
      this.$set(row, 'isEdit', true)
    },
    saveRowEvent(row) {
      if (this.funcVerify(row)) {
        this.$set(row, 'roleCodeVisible', true)
      } else {
        this.$set(row, 'isEdit', false)
      }
    },
    cancelRowEvent(row, rowIndex) {
      if (this.funcVerify(row)) {
        this.tableData.splice(rowIndex, 1)
      } else {
        this.$set(row, 'isEdit', false)
      }
    },
    delRowEvent(row, rowIndex) {
      this.$confirm('确认刪除吗？')
        .then(_ => {
          this.tableData.splice(rowIndex, 1)
        })
        .catch(_ => {})
    },
    upRowEvent(rowIndex) {
      if (rowIndex - 1 < 0) {
        this.$message({ message: '已置顶！', type: 'error' })
      } else {
        this.tableData.splice(
          rowIndex - 1,
          0,
          this.tableData.splice(rowIndex, 1)[0]
        )
      }
    },
    downRowEvent(rowIndex) {
      if (rowIndex + 1 === this.tableData.length) {
        this.$message({ message: '已置底！', type: 'error' })
      } else {
        this.tableData.splice(
          rowIndex + 1,
          0,
          this.tableData.splice(rowIndex, 1)[0]
        )
      }
    },
    findList() {
      this.loading = true
      request({
        url: '/ntocc-basic-api/reviewProcess/list',
        method: 'get',
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data
      })
    },
    funcSave() {
      let isOk = true
      for (const i in this.tableData) {
        if (this.funcVerify(this.tableData[i])) {
          this.$set(this.tableData[i], 'roleCodeVisible', true)
          isOk = false
        }
      }
      const data = this.tableData
      if (isOk) {
        this.$confirm('确认保存吗？')
          .then(_ => {
            const rLoading = this.openLoading();
            request({
              url: '/ntocc-basic-api/reviewProcess/'+this.listQuery.type,
              method: 'post',
              data
            }).then(response => {
              rLoading.close();
              this.$message({ message: response.msg, type: 'success' })
              this.findList()
            })
          })
          .catch(_ => {})
      }
    },
    funcVerify(row) {
      if (row.roleCode === void 0 || row.roleCode === '') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style type="text/css">
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
}
.titleh1 code {
  width: 5px;
  height: 20px;
  background-color: #ff7f21;
  float: left;
  margin-right: 5px;
  margin-top: 13px;
}
.verify-tip.el-tooltip__popper.is-light {
  background: #fff;
  border: 1px solid red;
  color: red;
}
.verify-tip.el-tooltip__popper.is-light[x-placement^="top"] .popper__arrow {
  border-top-color: red;
}
.verify-tip.el-tooltip__popper.is-light[x-placement^="right"] .popper__arrow {
  border-right-color: red;
}

</style>

